import { BaseBus } from "./BaseBus";
import { DateFunctions } from "../static/date-functions";
import { VendorReturnDetailBus } from "./VendorReturnDetailBus";
import { CommonFunctions } from "../static/common-functions";

export class BillingCodeBus extends BaseBus {
    constructor(busObj: BaseBus = null) {
        super(busObj);
        this.insertDt = DateFunctions.getDate(this.insertDt);
        this.updateDt = DateFunctions.getDate(this.updateDt);

    }

    CID(): any {
        return this.billingCodeId;
    }
    setCommon(userId: any, date: Date, companyId: any = null, personId: any = null) {
        if (!DateFunctions.isValidDate(this.insertDt)) {
            this.insertDt = date;
            this.insertUserId = userId;
        }
        this.updateDt = date;
        this.updateUserId = userId;
    }
    setFromForm(data: BillingCodeBus) {
        super.setFromForm(data);
        let dateNow = CommonFunctions.getDateNow();
        this.updateDt = dateNow;
        this.updateUserId = data.insertUserId;
        if (this.hasId) {
            //this.updateDt = dateNow;
            this.insertDt = data.insertDt;
            this.insertUserId = data.insertUserId;
        }
        else {
            this.insertDt = dateNow;
            this.insertUserId = data.insertUserId;
        }

    }
    setBeforeSave() {
        this.insertDt = DateFunctions.getDateTimeWithUTCOffset(this.insertDt);
        // this.updateDt = DateFunctions.getDateTimeWithUTCOffset(this.updateDt);
    }
    isActive: boolean;
    billingCodeId: any;
    rate: number;
    cost: number;
    billingTypeId: any;
    billingCode: string;
    billingDesc: string;
    billingTypename: string;
    incomeAccountId: any;
    incomeAccountName: string;
    costDebitAccountId: any;
    costDebitAccountName: string;
    costCreditAccountName: string;
    costCreditAccountId: any;
    costMultiplier: number;
    qbID: string;
    qbEditSequenceid: string;
    invoiceCoaid: any;
    billCoaid: any;

    insertDt: Date;
    insertUserId: any;
    updateDt: Date;
    updateUserId: any;
}